import React from 'react';
import EmployeeLayout from '../../components/EmployeeLayout';
import EmployeeAccountingPage from '../../components/EmployeeAccountingPage';

export default function AccountingPage() {
  return (
    <EmployeeLayout>
      <EmployeeAccountingPage />
    </EmployeeLayout>
  );
}
